import { useQuery } from "@tanstack/react-query";
import analyticsService from "../../services/analytics/analytics.service";

// 0024: org-wide analytics for the Admin dashboard. Keyed on the token so a re-login never
// serves another user's cached numbers (same pattern as useUserInfoQuery). 60s staleTime —
// these are month-to-date aggregates, no need to refetch on every focus.
const useAdminAnalyticsQuery = ({ enabled = true } = {}) => {
  const token = localStorage.getItem("jwtToken");
  return useQuery({
    queryKey: ["analytics", "admin", token],
    queryFn: () => analyticsService.getAdminSummary().then((r) => r.data.payload),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export default useAdminAnalyticsQuery;
